// extracted by mini-css-extract-plugin
module.exports = {"main":"manager_main__1UjIW","mainFullWidth":"manager_mainFullWidth__1rTXT"};